import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useTranslation } from "react-i18next";

export const cameraPage = (items, page, size = 4) => {
  const lastPage = Math.max(0, Math.ceil(items.length / size) - 1);
  const current = Math.min(Math.max(0, page), lastPage);
  return { items: items.slice(current * size, (current + 1) * size), page: current, lastPage };
};

const CameraPager = ({ count, page, onChange, size = 4 }) => {
  const { t } = useTranslation();
  const last = Math.max(0, Math.ceil(count / size) - 1);
  const current = Math.min(page, last);
  return <Box display="flex" alignItems="center" gap={1} data-camera-pager>
    <Typography variant="caption" aria-live="polite">{t("platform.monitoringTools.cameraRange", { from: count ? current * size + 1 : 0, to: Math.min((current + 1) * size, count), count })}</Typography>
    <Tooltip title={t("platform.monitoringTools.previousCameras")}><span><IconButton aria-label={t("platform.monitoringTools.previousCameras")} disabled={current === 0} onClick={() => onChange(current - 1)}><ChevronLeftIcon /></IconButton></span></Tooltip>
    <Tooltip title={t("platform.monitoringTools.nextCameras")}><span><IconButton aria-label={t("platform.monitoringTools.nextCameras")} disabled={current >= last} onClick={() => onChange(current + 1)}><ChevronRightIcon /></IconButton></span></Tooltip>
  </Box>;
};

export default CameraPager;
